import jsonServerProvider from 'ra-data-json-server';

// For Analytics custom call
import { fetchUtils } from 'ra-core';
import { stringify } from 'query-string';


const apiUrl = '/api';
const httpClient = fetchUtils.fetchJson;

export const dataProvider = jsonServerProvider('/api');

const buildAPIUrl = ( resource, query ) => {
	return `${apiUrl}/${resource}?${stringify(query)}`;
};

async function getAnalytics(resource, params) {
	const query = {
		...fetchUtils.flattenObject(params.filter)
	};

	const url = buildAPIUrl( resource, query );
	const { json } = await httpClient(url, {
		method: 'POST'
	});
	return { data: json };
};

dataProvider.getAnalytics = async (params) => getAnalytics( 'analytics', params );

dataProvider.getAnalyticsCSV = async (params) => {
	const query = {
		format: 'csv',
		...fetchUtils.flattenObject(params.filter)
	};

	const url = buildAPIUrl( 'analyticscsv', query );
	const { json } = await httpClient(url, {
		method: 'POST'
	});
	return { data: json };
};

dataProvider.refreshSummaries = async ({ force }) => {
	const query = {};
	if ( force ) {
		query.force = 1;
	}

	const url = buildAPIUrl( 'analytics/summaryrefresh', query );
	const { json } = await httpClient(url, {
		method: 'POST'
	});
	return { data: json };
}

dataProvider.cloneModule = async ({ id, session_id }) => {
	const url = `${apiUrl}/modules/${id}/clone`;
	const { json } = await httpClient(url, {
		method: 'POST',
		headers: new Headers({ 'Content-Type': 'application/json' }),
		body: JSON.stringify({ session_id })
	});
	return { data: json };
};

dataProvider.importUsers = async ({ csv, dryRun }) => {
	const url = `${apiUrl}/users/import`;
	const { json } = await httpClient(url, {
		method: 'POST',
		headers: new Headers({ 'Content-Type': 'application/json' }),
		body: JSON.stringify({ csv, dryRun })
	});
	return { data: json };
};

dataProvider.previewPrompt = async (params) => {
	const url = `${apiUrl}/prompt-preview`;
	const { json } = await httpClient(url, {
		method: 'POST',
		headers: new Headers({ 'Content-Type': 'application/json' }),
		body: JSON.stringify(params)
	});
	return { data: json };
};

export default dataProvider;
